export default __webpack_public_path__ + "static/media/psm-white.acd32955.svg";